import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import IconHelp from 'client/icons/Help'
import IconStaywallet from 'client/icons/Staywallet'
import Price from 'client/components/Price'
import Tooltip from 'client/components/Tooltip'

import { StaywalletBase } from './styles'
import messages from './messages'

const Staywallet = ({ amount, currency, tooltip, isEarned }) => {
  if (!amount) {
    return null
  }

  const creditAmount = {
    amount: (
      <strong>
        <Price amount={amount} currency={currency} />
      </strong>
    ),
  }

  return (
    <StaywalletBase data-testid="staywallet-box">
      <IconStaywallet />
      <FormattedMessage
        {...messages[isEarned ? 'youWonCredit' : 'earnStaywallet']}
        values={creditAmount}
        tagName="p"
      />

      {tooltip && (
        <Tooltip
          maxContainerWidth={250}
          content={
            <FormattedMessage {...messages.staywalletTooltip} values={creditAmount} tagName="p" />
          }
        >
          <IconHelp />
        </Tooltip>
      )}
    </StaywalletBase>
  )
}

Staywallet.propTypes = {
  amount: PropTypes.number,
  currency: PropTypes.string,
  isEarned: PropTypes.bool,
  tooltip: PropTypes.bool,
}

export default Staywallet
